import { useState, useEffect } from "react";
import InputWithLabel from "./InputWithLabel";
import Button from "../buttons/button";
import useTranslator from "../../../hooks/useTranslator";

const initialFormData = {
  batch_code: "",
  washing_at: "",
  supplier_name: "",
};

const WashingAreaFilter = ({ onApplyFilter, onClose, filters = {} }) => {
  const [filtersData, setFiltersData] = useState({
    batch_code: filters.batch_code || "",
    washing_at: filters.washing_at || "",
    supplier_name: filters.supplier_name || "",
  });

  const { _t } = useTranslator();

  useEffect(() => {
    setFiltersData({
      batch_code: filters.batch_code || "",
      washing_at: filters.washing_at || "",
      supplier_name: filters.supplier_name || "",
    });
  }, [filters.batch_code, filters.washing_at, filters.supplier_name]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFiltersData({ ...filtersData, [name]: value });
  };

  const handleReset = (e) => {
    e.preventDefault();
    setFiltersData(initialFormData);
    onApplyFilter(initialFormData);
    if (onClose) onClose();
  };

  const handleApply = (e) => {
    e.preventDefault();
    onApplyFilter({ ...filtersData });
    if (onClose) onClose();
  };


  return (
    <div className="dropdown_body">
        <h5 className="mb-3 border-bottom">{_t("filter_heading", "Filter")}</h5>
        <InputWithLabel
            label={_t("batch_code", "Batch Code")}
            type="text"
            name="batch_code"
            value={filtersData.batch_code}
            onChange={handleChange}
        />

         <InputWithLabel
          label={_t("washing_date_from", "Wash Ready At")}
          type="date"
          name="washing_at"
          value={filtersData.washing_at}
          onChange={handleChange}
        />

        <InputWithLabel
            label={_t("supplier_name", "Supplier Name")}
            type="text"
            name="supplier_name"
            value={filtersData.supplier_name}
            onChange={handleChange}
        />

      <div className="d-flex justify-content-between mt-3">
        <Button
          onClick={handleReset}
          label={_t("reset_button", "Reset")}
          className="reset_btn"
        />
        <Button
          className="cmn_btn"
          label={_t("apply_button", "Apply")}
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default WashingAreaFilter;
